<script setup>
import AutocompleteFilter from '@/components/widgets/AutocompleteFilter.vue';
import { ref, inject, onMounted } from 'vue';

const backendApi = inject('backendApi');

const emit = defineEmits(['update', 'update:focused']);
defineProps({
    hideLabel: {
        type: Boolean,
        default: false
    }
});

const selected = ref(null);
const loading = ref(true);
const paidTypes = ref([]);
const showRetryButton = ref(false);
const searchQuery = ref('');

const getConsolTypes = () => {
    cleanData();

    backendApi()
        .paidType()
        .index({
            pattern: searchQuery.value,
            active: true
        })
        .then(success, fail)
        .finally(() => (loading.value = false));

    function success(response) {
        paidTypes.value = response.data;
    }

    function fail() {
        showRetryButton.value = true;
    }
};

const cleanData = () => {
    paidTypes.value = [];
    loading.value = true;
    showRetryButton.value = false;
};

onMounted(() => getConsolTypes());
</script>

<template>
    <AutocompleteFilter
        v-model="selected"
        v-model:search="searchQuery"
        :items="paidTypes"
        item-title="name"
        item-value="id"
        :label="hideLabel ? '' : $t('Paid Type')"
        :loading="loading"
        :show-retry-button="showRetryButton"
        @update="emit('update', selected)"
        @preparing-search="cleanData"
        @search="getConsolTypes"
        @retry="getConsolTypes"
        @update:focused="(state) => emit('update:focused', state)"
    >
        <template v-slot:default="{ props, item }">
            <v-list-item
                v-bind="props"
                :title="`${item.raw.name}`"
                :subtitle="`${
                    item.raw.description ? item.raw.description : ''
                }`"
            ></v-list-item>
        </template>
        <template v-if="$slots.prepend" v-slot:prepend>
            <slot name="prepend"></slot>
        </template>
    </AutocompleteFilter>
</template>
